import { 
    Modal,
    ModalBody,
    ModalHeader,
} from 'reactstrap'
import './HomeClient.scss'
import * as React from 'react'
import { useTranslations } from '../../../store/translations/hooks'
import { CompanyPublicData } from '../../../models'
import { TK } from '../../../store/translations/translationKeys'
import { useDispatch } from 'react-redux'
import { getAppointmentAsync } from '../../../ajax/requests'
import { loadEntities } from '../../../store/entities/actions'
import { PrettyScheduler } from './components/PrettyScheduler'

export const SelfScheduleModal: React.FC<{
    isOpen: boolean,
    toggle: () => void,
    company: CompanyPublicData,
}> = ({
    isOpen,
    toggle,
    company,
}) => {
    const t = useTranslations()

    const dispatch = useDispatch()

    return (
        <Modal size="lg" isOpen={!!isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t(TK.schedule)}
            </ModalHeader>
            <ModalBody className="schedule-modal">
                <PrettyScheduler
                    company={company}
                    onDone={appointmentId => {
                        toggle()
                        dispatch(loadEntities('appointments', () => getAppointmentAsync(appointmentId), 'AppendResult'))
                    }} 
                />
            </ModalBody>
        </Modal> 
    )
}
